import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form, Carousel, InputGroup, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './CardModal.css';
import CardRating from './CardRating';
import Pagination from './Pagination'; // Assuming this is the correct path for Pagination
import axios from 'axios';
import { FaHeart, FaRegHeart, FaSmile, FaClipboard, FaFlag, FaShare, FaReply, FaEllipsisV, FaEdit, FaShieldAlt, FaTrash, FaFileImport, FaPlusCircle, FaMinusCircle, FaPlus, FaMinus, FaComments, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import CardPicker from './CardPicker';
import { useUser } from '../UserContext'; // Import the useUser hook
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import CommentForm from './CommentForm';
import ReportModal from './ReportModal';
import moment from 'moment';
import DOMPurify from 'dompurify';
import { useModeratorAction } from '../ModeratorActionContext';
import VotingSection from './VotingSection';

import { buildUrlWithParams } from './utils.js'


function formatDateWithTooltip(creationDate) {
    const date = moment(creationDate);
    const diffInDays = moment().diff(date, 'days');
    
    let displayText;
    if (diffInDays === 0) {
        displayText = 'Today';
    } else if (diffInDays === 1) {
        displayText = '1 day ago';
    } else if (diffInDays < 30) {
        displayText = `${diffInDays} days ago`;
    } else if (diffInDays < 365) {
        const months = moment().diff(date, 'months');
        displayText = months === 1 ? '1 month ago' : `${months} months ago`;
    } else {
        const years = moment().diff(date, 'years');
        displayText = years === 1 ? '1 year ago' : `${years} years ago`;
    }

    const renderTooltip = (props) => (
        <Tooltip id="date-tooltip" {...props}>
            {date.format('MMMM Do YYYY, h:mm a')}
        </Tooltip>
    );

    return (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
            <span>{displayText}</span>
        </OverlayTrigger>
    );
}

function timeSince(timestamp) {
    const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
    const timeDifference = timestamp;

    if (timeDifference === 0) {
        return 'just now';
    } else if (timeDifference < 60) {
        return timeDifference + ' second' + (timeDifference === 1 ? ' ago' : 's ago');
    } else if (timeDifference < 3600) {
        const minutes = Math.floor(timeDifference / 60);
        return minutes + ' minute' + (minutes === 1 ? ' ago' : 's ago');
    } else if (timeDifference < 86400) {
        const hours = Math.floor(timeDifference / 3600);
        return hours + ' hour' + (hours === 1 ? ' ago' : 's ago');
    } else if (timeDifference < 2629746) { // less than a month (30.44 days on average)
        const days = Math.floor(timeDifference / 86400);
        return days + ' day' + (days === 1 ? ' ago' : 's ago');
    } else if (timeDifference < 31536000) { // less than a year (365 days)
        const months = Math.floor(timeDifference / 2629746); // seconds in a month (on average)
        return months + ' month' + (months === 1 ? ' ago' : 's ago');
    } else {
        const years = Math.floor(timeDifference / 31536000); // seconds in a year
        return years + ' year' + (years === 1 ? ' ago' : 's ago');
    }
}

const emoticonMap = { "thinking": { srcset: 1 }, "woodenReno": { srcset: 1 }, "jaraxxus-thinking": { srcset: 1 }, "jaraxxus": { srcset: 1 }, "razorpetal": { srcset: 1 }, "bananas": {}, "annoy-o-tron": { srcset: 1 }, "aannoy-o-tron": { animated: 1 }, "smorc": { srcset: 1 }, "tinyfin": { srcset: 1 }, "common": { srcset: 1 }, "rare": { srcset: 1 }, "epic": { srcset: 1 }, "legendary": { srcset: 1 }, "boombot": { srcset: 1 }, "horde": { srcset: 1 }, "alliance": { srcset: 1 }, "snake": { srcset: 1 }, "boomS": { srcset: 1 }, "chicken": { srcset: 1 }, "wow": { srcset: 1 }, "finleySmile": { srcset: 1 }, "reno": { srcset: 1 }, "illidon": { srcset: 1 }, "bob": { srcset: 1 }, "cat": { srcset: 1 }, "shrugillL": { srcset: 1 }, "shrugillR": { srcset: 1 }, "voidw": { srcset: 1 }, "blingtron": { srcset: 1 }, "dhguy": { srcset: 1 }, "rainbow": { srcset: 1 }, "faelin": { srcset: 1 }, "skelehead": { srcset: 1 }, "treeh": { srcset: 1 }, "ghoul": { srcset: 1 }, "pensive": { srcset: 1 }, "trumpet": { srcset: 1 }, "scared": { srcset: 1 }, "frogface": { srcset: 1 }, "thumbsup": { srcset: 1 }, "clowno": { srcset: 1 }, "fintective": { srcset: 1 }, "rafaamPog": { srcset: 1 }, "finking": { srcset: 1 }, "shocked": { srcset: 1 }, "waveflipper": { srcset: 1 }, "wavedummy": { srcset: 1 }, "happyButtons": { srcset: 1 }, "lynessa": { srcset: 1 }, "murlocMarine": { srcset: 1 }, "qnikkoHi": { srcset: 1 }, "aqnikkoHi": { srcset: 1, animated: 1 }, "treeLove": { srcset: 1 }, "qnikkoWhat": { srcset: 1 }, "qWOW": { srcset: 1 }, "aqWOW": { srcset: 1, animated: 1 }, "qLOVE": { srcset: 1 }, "qCRY": { srcset: 1 }, "qCozy": { srcset: 1 }, "qCool": { srcset: 1 }, "qTPie": { srcset: 1 }, "qSleep": { srcset: 1 } };

const replaceEmotes = (text, emoticonMap) => {
	
	
// Function to check if the URL is a YouTube link
    function isYouTubeLink(url) {
        return url.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/) !== null;
    }


// Function to check if the URL is an approved image
function isApprovedImage(url) {
    return url.match(/\.(jpeg|jpg|gif|png|webp)$/) !== null;
}

    // Replace URLs with appropriate links or embeds
    text = text.replace(/\b(https?:\/\/\S+)\b/g, (match) => {
        if (isYouTubeLink(match)) {
            const videoId = match.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/)[1];
            return `<iframe src="https://www.youtube.com/embed/${videoId}" frameborder="0" allowfullscreen class="video-container"></iframe>`;
        } else if (isApprovedImage(match)) {
            return `<p><a href="${match}" target="_blank"><img src="${match}" style="max-width: 100%; max-height: 350px; margin-top: 5px; border-radius: 5px;" /></a></p>`;
        } else {
            return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`;
        }
    });

	
    // Replace URLs
    //text = text.replace(/(https?:\/\/[^\s]+)/g, (url) => {
    //    const isLocal = url.startsWith('https://www.hearthcards.net/');
    //    const localIcon = isLocal ? '<img src="https://www.hearthcards.net/galtest/hearthcards-logo.webp" alt="local icon" class="local-icon" style="width: 20px; height: 20px; margin-right: 2px;">' : '';
    //    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${localIcon}${url}</a>`;
    //});
	

	
      const cardTagRegex = /\[card id='(\d+)'](.*?)\[\/card]/g;
      const replaceTagWithLink = (match, cardId, cardName) => {
        const localIcon = '<img src="/images/hearthcards-logo.webp" alt="local icon" class="local-icon" style="width: 20px; height: 20px; margin-right: 2px;">';
        const url = `/gallery/?selectedCard=${cardId}`;
        return `<a href="${url}" rel="noopener noreferrer">${localIcon}${cardName}</a>`;
      };

      text = text.replace(cardTagRegex, replaceTagWithLink);

    // Replace newlines with <br>
    text = text.replace(/\n/g, '<br>');
	
    // Replace emotes
    text = text.replace(/:([a-zA-Z0-9_-]+):/g, (match, emote) => {
        const emoteData = emoticonMap[emote];
        if (!emoteData) {
            return match; // If emote not found in the map, return the original text
        }

        const isAnimated = emoteData.animated;
        const srcset1x = `https://www.hearthcards.net/images/emotes/${emote}${isAnimated ? '.gif' : '.png'}`;
        const srcset2x = `https://www.hearthcards.net/images/emotes/${emote}${isAnimated ? '.gif' : '2.png'}`;
        const srcset4x = `https://www.hearthcards.net/images/emotes/${emote}${isAnimated ? '.gif' : '3.png'}`;

        return `<img 
                    src="${srcset1x}" 
                    ${emoteData.srcset ? `srcset="${srcset1x} 1x, ${srcset2x} 2x, ${srcset4x} 4x"` : ''}
                    alt="${emote}" 
                    class="emote-image"
                />`;
    });

    return text;
};

const escapeHTML = (str) => {
    return str.replace(/[&<>'"]/g, 
      tag => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;'
      }[tag] || tag)
    );
  };

    const processCommentText = (text) => {

        return  replaceEmotes(DOMPurify.sanitize(text, { 
            ALLOWED_TAGS: ['br', 'a'],
            ALLOWED_ATTR: ['href', 'target', 'rel']
          }), emoticonMap);

    };

    const reportReasons = {
        card: [
          'Inappropriate Card Content',
          'Inappropriate Card Art',
          'Spam / Unrelated Content',
        ],
        comment: [
          'Harassment',
          'Spam',
          'Inappropriate profile picture',
        ],
      };

const CardModal = ({ card, setCards, user, onClose, show, newCard }) => {
    const [cardDetails, setCardDetails] = useState(null);
    const [comments, setComments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [newComment, setNewComment] = useState('');
    const [totalPages, setTotalPages] = useState(1);
    const [totalComments, setTotalComments] = useState(0);
    const [isInGallery, setIsInGallery] = useState(false);
    const [putError, setPutError] = useState(null);
    const { openModModal } = useModeratorAction();
    const { settings, cards } = useUser(); // Destructure setSelectedUser from the context

    const buildCardLink = (cardId) => {
      return buildUrlWithParams({
        ...Object.fromEntries(new URLSearchParams(window.location.search)),
        selectedCard: cardId,
      });
    };
    
    const handlePrevCardLink = () => {
      if (card) {
        const currentCardIndex = cards.findIndex(cardS => cardS.id === card);
        if (currentCardIndex > 0) {
          return buildCardLink(cards[currentCardIndex - 1].id);
        }
      }
      return "#"; // Fallback if no previous card
    };
    
    const handleNextCardLink = () => {
      if (card) {
        const currentCardIndex = cards.findIndex(cardS => cardS.id === card);
        if (currentCardIndex < cards.length - 1) {
          return buildCardLink(cards[currentCardIndex + 1].id);
        }
      }
      return "#"; // Fallback if no next card
    };
    

    const handleModRemoveComment = (commentId) => {
      openModModal('comment', commentId);
    };
    const handleRemoveCard = (cardId) => {
      openModModal('card', cardId);
    };
  
    const cardsPerRow = settings.cardsPerRow;

    useEffect(() => {
        if (cardDetails) {
            setIsInGallery(Number(cardDetails.cardInfo.approvedGallery) === 2 || Number(cardDetails.cardInfo.approvedGallery) === 1);
        }
    }, [cardDetails]);

    const handleGalleryToggle = async () => {
        try {
            const response = await axios.post('/api/card/putingallery.php', {
                action: isInGallery ? 'remove' : 'add',
                cardId: cardDetails.cardInfo.cardId,
            });

            if (response.data.success) {
                setIsInGallery(!isInGallery);
                setCardDetails(prevState => ({
                    ...prevState,
                    cardInfo: {
                        ...prevState.cardInfo,
                        approvedGallery: isInGallery ? 0 : 2 || 1
                    }
                }));
                setPutError(null); // Clear any previous errors
              } else {
                setPutError(response.data.message || 'Failed to update gallery status');
              }
        } catch (err) {
            console.error('Error updating gallery status:', err);
            alert('An error occurred while updating the gallery status');
        }
    };


    const [showReportModal, setShowReportModal] = useState(false);
    const [reportType, setReportType] = useState('');
    const [reportItemId, setReportItemId] = useState(null);

    const openReportModal = (type, id) => {
        setReportType(type);
        setReportItemId(id);
        setShowReportModal(true);
      };
	

    const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [showEmotePicker, setShowEmotePicker] = useState(false);
	const [showPicker, setShowPicker] = useState(false);
    const [cardPickerType, setCardPickerType] = useState('attach');
    const [selectedCards, setSelectedCards] = useState([]);
	
const [showShareModal, setShowShareModal] = useState(false);
	
const [editingCommentId, setEditingCommentId] = useState(null);
const [deletingCommentId, setDeletingCommentId] = useState(null);


const [editedCommentText, setEditedCommentText] = useState('');
const [showCommentDeleteModal, setShowCommentDeleteModal] = useState(false);
	
const [replyingCommentId, setReplyingCommentId] = useState(null);
const handleReplyClick = (commentId) => {
    setReplyingCommentId(commentId);
  };



  const location = useLocation();
  const navigate = useNavigate();

  const isContestPage = location.pathname.includes("/contests/");

    // Calculate previous and next card IDs (same logic as before)
    let prevCardId = null;
    let nextCardId = null;

    if (card && cards && cards.length > 0) {
        const currentCardIndex = cards.findIndex(cardS => cardS.id === card);

        // Check if a previous card exists
        if (currentCardIndex > 0) {
            prevCardId = cards[currentCardIndex - 1].id;
        }

        // Check if a next card exists
        if (currentCardIndex !== -1 && currentCardIndex < cards.length - 1) {
            nextCardId = cards[currentCardIndex + 1].id;
        }
    }


  
//   const handleUserClick = (userId) => {
//     setSelectedUser(userId);
//     onClose(); // Optionally close the modal if necessary
//   };
//document.body.style.overflow = 'hidden';


	const fetchCardDetails = async () => {
		const response = await fetch(`/api/card/card-stuff_react.php?cardid=${card}`);
		const data = await response.json();
		setCardDetails(data);
		//document.body.style.overflow = 'hidden';
	};

    useEffect(() => {
        setCardDetails(null);
        fetchCardDetails();
    }, [card]);

        const fetchComments = async (page) => {
            const response = await fetch(`/api/comments/comments-stuff.php?id=${card}&page=${page}`);
            const data = await response.json();
            setComments(data.comments);
            setTotalPages(data.main.maxpage);
            setTotalComments(data.main.total);
        };

        

    useEffect(() => {
        fetchComments(currentPage);
    }, [card, currentPage]);

    useEffect(() => {
        const hash = location.hash;
        const page = parseInt(hash.replace('#', ''), 10);
        if (!isNaN(page) && page > 0) {
            setCurrentPage(page);
        } else {
            setCurrentPage(1);
        }
    }, [location.hash]);

    if (!cardDetails) {
        return <div className="card-modal d-flex justify-content-center align-items-center" style={{ height: '100vh' }} onClick={onClose}>
        Loading...
        </div>
    }




    const handleCommentChange = (e) => {
        setNewComment(e.target.value);
    };

	// const handleCommentSubmit = async (e) => {
	// 	e.preventDefault();
	// 	const userComment = {
	// 		cardid: cardDetails.cardInfo.cardId,
	// 		cardid2: cardDetails.cardInfo.cardId2,
	// 		comment: newComment,
	// 		sticky: '',
	// 		usercards: selectedCards,
	// 		gimmick: '',
	// 	};	
	// 	//console.log(userComment);
	// 	try {
	// 		const response = await axios.post('/api/comments/post-comment.php', userComment);
	// 		if (response) {
	// 			// Clear the input box
	// 			setNewComment('');
    //             setSelectedCards([]);
	// 			// Refresh the comments
	// 			if (currentPage !== 1) {
	// 			setCurrentPage(1);
	// 			} else {
	// 			fetchComments(currentPage);
	// 			}
	// 		} else {
	// 			alert('Failed to post comment');
	// 		}
	// 	} catch (err) {

	// 	}
	// };

    const handleCommentSubmit = async (newComment) => {
        if (currentPage !== 1) {
          setCurrentPage(1);
        } else {
          fetchComments(currentPage);
        }
      };

      const handleCardEditButton = async () => {
        if (tokens && tokens.length > 0) {
          setCardPickerType('edit');
          setShowPicker(true);
        } else {
          window.location.href = `https://www.hearthcards.net/?action=edit&id=${cardInfo.cardId2}&nid=${cardInfo.cardId}&redirect=1`;
        }
      };      
	
    const handleDelete = async () => {
        try {
            const response = await axios.post('/api/card/delete-card.php', {
                action: 'delete',
                cid: cardInfo.cardId2,
            });
            if (response.data.success) {
                //alert('Card deleted successfully');
                setShowDeleteModal(false);
                onClose(); // Close the modal after deletion
                setCards(prevCards => prevCards.filter(card => Number(card.id) !== Number(cardInfo.cardId)));
            } else {
                alert('Failed to delete card');
            }
        } catch (err) {
            alert('An error occurred while deleting the card');
            console.log(err);
        }
    };
	
    const handleLikeComment = async (commentId) => {
        try {
            const response = await axios.post('/api/comments/like-a-comment.php', {
                commentId: commentId,
            });
            if (response.data.liked === 1) {
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === commentId
                            ? { ...comment, likes: response.data.likes, liked: response.data.liked }
                            : comment
                    )
                );
            } else {
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === commentId
                            ? { ...comment, likes: response.data.likes, liked: response.data.liked }
                            : comment
                    )
                );
            }
        } catch (err) {
            alert('An error occurred while liking the comment');
        }
    };
	
    const handleFavorite = async (cardId) => {
        try {
            const response = await axios.post('/api/card/favorite.php', {
                cid: cardId,
            });
            if (Number(response.data.state) === 1) {
				setCardDetails(prevState => ({
				  ...prevState,
				  cardInfo: {
					...prevState.cardInfo,
					favstate: 1
				  }
				}));
            } else {
				setCardDetails(prevState => ({
				  ...prevState,
				  cardInfo: {
					...prevState.cardInfo,
					favstate: 0
				  }
				}));
            }
        } catch (err) {
            alert('An error occurred while liking the comment');
        }
    };

    const handleDownloadImage = () => {
      const cardId = card; // Assuming `card` is the variable holding the card ID
    
      fetch(`/api/card/share-image.php?card_id=${cardId}`)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.blob();
        })
        .then(blob => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `card_${cardId}.webp`); // Name of the downloaded file
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch(error => {
          console.error('Error downloading the image:', error);
        });
    };
    
	
    const handleEmoteClick = (emote) => {
        const textArea = document.getElementById("newComment");
        const emoteText = `:${emote}:`;
        
        if (typeof textArea.selectionStart !== "undefined") {
            const begin = textArea.value.substr(0, textArea.selectionStart);
            const selection = textArea.value.substr(textArea.selectionStart, textArea.selectionEnd - textArea.selectionStart);
            const end = textArea.value.substr(textArea.selectionEnd);
            const spaceBefore = !textArea.value || textArea.value.substr(textArea.selectionStart - 1, 1) === " " ? "" : " ";
            const spaceAfter = textArea.value.substr(textArea.selectionEnd, 1) === " " ? "" : " ";
            
            textArea.value = begin + spaceBefore + emoteText + spaceAfter + end;
            setNewComment(textArea.value);
        } else {
            setNewComment(newComment + emoteText);
        }
        
        //setShowEmotePicker(false);
        textArea.focus();
    };

    const { cardInfo, tokens } = cardDetails;

    const renderCardCarousel = (cards) => {
    return (
        <div className="d-flex flex-wrap">
            {cards.map((card, index) => (
                <img
                    key={index}
                    className="img-fluid"
                    src={`/cards/${card.cardid}.webp`}
                    alt={`Card ${index + 1}`}
                />
            ))}
        </div>
    );
};

	
  const handleCardSelection = (cards) => {
    if (cardPickerType === 'attach') {  
    setSelectedCards(cards);
    }
  };

  const handleClosePicker = () => {
    setShowPicker(false);
    if (cardPickerType === 'add' || cardPickerType === 'delete') {
      fetchCardDetails();
    }
  };



    const handleEditComment = (commentId) => {
        const comment = comments.find((c) => c.id === commentId);
        setEditingCommentId(commentId);
        setEditedCommentText(comment.comment);
    };

    const handleSaveComment = async (commentId) => {
        try {
            const response = await axios.post('/api/comments/update-comment.php', {
                id: commentId,
                text: editedCommentText,
            });

            if (response.data.success) {
                setComments((prevComments) =>
                    prevComments.map((comment) =>
                        comment.id === commentId
                            ? { ...comment, comment: editedCommentText }
                            : comment
                    )
                );
                setEditingCommentId(null);
                setEditedCommentText('');
                setSelectedCards(null);
            } else {
                alert('Failed to update comment');
            }
        } catch (err) {
            alert('An error occurred while updating the comment');
        }
    };
	
	
    const handleDeleteComment = (commentId) => {
        setDeletingCommentId(commentId);
		setShowCommentDeleteModal(true);
    };
	
const handleDeleteCommentRequest = async () => {
        try {
            const response = await axios.post('/api/comments/update-comment.php', {
                id: deletingCommentId,
                text: '',
            });
			if (response.data.success) {
				setComments((prevComments) =>
					prevComments.filter((comment) => comment.id !== deletingCommentId)
				);
                setDeletingCommentId(null);
				setShowCommentDeleteModal(false);
            } else {
                alert('Failed to delete comment');
            }
        } catch (err) {
            alert('An error occurred while deleting the comment');
        }
};


    const handleCopyLink = (e) => {
		const button = e.currentTarget;
        button.classList.remove('btn-primary');
        button.classList.add('btn-success');
        setTimeout(() => {
            button.classList.remove('btn-success');
            button.classList.add('btn-primary');
        }, 1000);
        const link = `https://www.hearthcards.net/gallery/?selectedCard=${card}`;
        navigator.clipboard.writeText(link);
    };



    return (
        <>
            {card && (
                <div className="card-modal">
				
        {isContestPage && prevCardId && ( // Only render if a previous card exists
                <Link
                    to={buildUrlWithParams({ selectedCard: prevCardId })}
                    preventScrollReset={true}
                    className="position-fixed top-50 translate-middle-y modal-arrows"
                    style={{
                        transform: 'translateY(-50%)',
                        zIndex: 1050,
                        left: '10px',
                        cursor: 'pointer',
                        textDecoration: 'none'
                    }}
                    aria-label="Previous Card"
                >
                    <FaChevronLeft
                        size={40}
                        className="text-white bg-dark bg-opacity-50 rounded-circle p-2"
                    />
                </Link>
            )}

            {/* Right Navigation Link - Desktop Only */}
            {isContestPage && nextCardId && ( // Only render if a next card exists
                 <Link
                    to={buildUrlWithParams({ selectedCard: nextCardId })}
                    preventScrollReset={true}
                    className="position-fixed top-50 translate-middle-y modal-arrows"
                    style={{
                        transform: 'translateY(-50%)',
                        zIndex: 1050,
                        right: '580px', // Adjust positioning as needed
                        cursor: 'pointer',
                        textDecoration: 'none'
                    }}
                    aria-label="Next Card"
                 >
                    <FaChevronRight
                        size={40}
                        className="text-white bg-dark bg-opacity-50 rounded-circle p-2"
                    />
                 </Link>
            )}



		{showPicker && (
        <CardPicker
          type={cardPickerType}
		  card={cardInfo.cardId2}
          onConfirm={handleCardSelection}
          onClose={() => handleClosePicker()}
        />
      )}
				
                    {/* <div className="card-modal-header">
                        <h2>{cardInfo.cardName}</h2>
                        <button className="btn-close" onClick={onClose}></button>
                    </div> */}
                    <div className="card-modal-body">
                    <button className="btn-close position-absolute end-0 top-0 m-3" onClick={onClose}></button>

<div
    className="d-md-none position-absolute end-0 top-0 mt-5 me-3 text-center"
    onClick={() => {
        const commentsHeader = document.querySelector('.commentsHeader');
        if (commentsHeader) {
            commentsHeader.scrollIntoView({ behavior: 'smooth' });
        }
    }}
    title="Go to comments"
>
    <button className="goToCommentsButton">
        <FaComments size={20} />
    </button>
    <div className="small mt-0">{totalComments}</div>
</div>


                        <div className="row">
                            <div className="col-md card-modal-left d-flex align-items-center align-content-start justify-content-center flex-wrap" onClick={onClose}>
                              

                              <div className={`card-list ${tokens && tokens.length >= 2 ? `cards-per-row-${cardsPerRow}` : 'cards-per-row-1'}`}>
                            <div className={`card-in-modal`}>
                                <img
                                    src={`/cards/${cardInfo.cardId2}.${cardInfo.cardFormat}`}
                                    alt={cardInfo.cardName}
                                    className="img-fluid mb-3"
                                    onClick={onClose}
                                />
                              </div>
                                {tokens && tokens.length > 0 ? (
                                    tokens.map((token) => (
                                      <div className={`card-in-modal`}>
                                        <img
                                            key={token.id}
                                            src={`/cards/${token.id}.${token.format}`}
                                            alt={token.class}
                                            className="img-fluid mb-3"
                                            onClick={onClose}
                                        />
                                      </div>
                                    ))
                                ) : (
                                    ''
                                )}
                                
</div>
                            </div>
                            <div className="col-md card-modal-right">
                                <h3>{cardInfo.cardName}</h3>
                                <p>
  <span style={{ cursor: 'pointer' }}>{formatDateWithTooltip(cardInfo.creationDate)}</span>
  {cardInfo.creatorName && <> by <strong>
    <Link to={`/user/${cardInfo.creatorId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
      {cardInfo.creatorName}
    </Link></strong></>}
</p>

                                <Button variant="danger" size="sm" className="me-2" onClick={() => openReportModal('card', cardInfo.cardId)}><FaFlag /> Report</Button>
								<Button variant="primary" size="sm" className="me-2" onClick={() => setShowShareModal(true)}><FaShare /> Share</Button>
								{user && ( <Button variant="primary" size="sm" onClick={() => handleFavorite(cardInfo.cardId)} > {Number(cardInfo.favstate) === 1 ? <FaHeart color="red" /> : <FaRegHeart />} {Number(cardInfo.favstate) === 1 ? 'Favorited' : 'Favorite'} </Button> )}
                {user && user.mod === true && Number(user.userid) !== Number(cardInfo.creatorId) && (	
                <Button variant="danger" size="sm" className="ms-2"  onClick={() => handleRemoveCard(cardInfo.cardId)}><FaShieldAlt /> Remove Card</Button>
                )}
                
      {/* Conditionally render CardRating component */}
      {Math.round((new Date() - new Date(cardInfo.creationDate)) / (1000 * 60 * 60 * 24)) <= 180 &&
        (Number(cardInfo.approvedGallery) === 1 || Number(cardInfo.approvedGallery) === 2) && (
          <CardRating
            cardid={cardInfo.cardId}
            initialRating={cardInfo.cardRating}
            totalVotes={cardInfo.cardVoted}
            userRated={cardInfo.uRating ? cardInfo.uRating : 0}
          />
        )}

      {/* Conditionally render CardRating component
      {(Number(cardInfo.approvedGallery) === 2 || 
        (Number(cardInfo.approvedGallery) === 1 && 
        Math.round((new Date() - new Date(cardInfo.creationDate)) / (1000 * 60 * 60 * 24)) <= 180)) && (
          <CardRating
            cardid={cardInfo.cardId}
            initialRating={cardInfo.cardRating}
            totalVotes={cardInfo.cardVoted}
            userRated={cardInfo.uRating ? cardInfo.uRating : 0}
          />
        )} */}


{/* Conditionally render CardLike component based on voting period */}
{(Number(cardInfo.approvedGallery) === 5) && cardInfo.contest_data && (
  <VotingSection cardInfo={cardInfo} />
)}

      {/* Display warning if card is older than 180 days */}
      {/* {Math.round((new Date() - new Date(cardInfo.creationDate)) / (1000 * 60 * 60 * 24)) > 180 && (
        <div className="p-3 mb-2 bg-danger text-white mt-2">
          This card is too old to be be rated.
        </div>
      )} */}
                                {cardInfo.removeReason ? <div className="p-3 mb-2 bg-danger text-white mt-2">{cardInfo.removeReason}</div> : ''}
                                {putError && (
                                    <div className="p-3 mb-2 alert alert-danger mt-2" role="alert">
                                      {putError}
                                    </div>
                                )}

								
                                {user && Number(user.userid) === Number(cardInfo.creatorId) && cardDetails.cardInfo.approvedGallery != '6' && (
  <div className="mainControls mt-3">
    <div className="cardControl mb-3 d-flex justify-content-between gap-3">
      <Button
        variant="danger"
        className="flex-fill d-flex flex-column align-items-center justify-content-center w-25"
        style={{ flexBasis: "0" }}
        onClick={() => setShowDeleteModal(true)}
      >
        <FaTrash className="mb-1" style={{ fontSize: '1.2rem', marginTop: '0.225em' }} />
        <span>Delete</span>
      </Button>
      <Button
        variant="primary"
        className="flex-fill d-flex flex-column align-items-center justify-content-center w-25"
        style={{ flexBasis: "0" }}
        onClick={handleCardEditButton}
      >
        <FaEdit className="mb-1" style={{ fontSize: '1.2rem', marginTop: '0.225em' }} />
        <span>Edit</span>
      </Button>
      <Button
        variant="primary"
        className="flex-fill d-flex flex-column align-items-center justify-content-center w-25"
        style={{ flexBasis: "0" }}
        onClick={() => window.location.href = `https://www.hearthcards.net/#${cardInfo.cardId2}`}
      >
        <FaFileImport className="mb-1" style={{ fontSize: '1.2rem', marginTop: '0.225em' }} />
        <span>Import</span>
      </Button>
      {cardDetails.cardInfo.approvedGallery != '5' ?
      <Button
        variant={isInGallery ? "danger" : "success"}
        className="flex-fill d-flex flex-column align-items-center justify-content-center w-25"
        style={{ flexBasis: "0" }}
        onClick={handleGalleryToggle}
      >
        {isInGallery ? <FaMinusCircle className="mb-1" style={{ fontSize: '1.2rem', marginTop: '0.225em' }} /> : <FaPlusCircle className="mb-1" style={{ fontSize: '1.2rem', marginTop: '0.225em' }} />}
        <span>{isInGallery ? "Unsubmit" : "Submit"}</span>
      </Button> : ''}
    </div>
    <div className="tokensControl mb-3 d-flex justify-content-between">
      <Button
        variant="success"
        className={tokens && tokens.length > 0 ? "flex-fill me-2" : "flex-fill"}
        onClick={() => {
          setCardPickerType('add');
          setShowPicker(true);
        }}
      >
        <FaPlus className="me-2" />Add Tokens
      </Button>
      {tokens && tokens.length > 0 ? (
        <Button
          variant="danger"
          className="flex-fill"
          onClick={() => {
            setCardPickerType('delete');
            setShowPicker(true);
          }}
        >
          <FaMinus className="me-2" />Remove Tokens
        </Button>
      ) : (
        ''
      )}


    </div>
    </div>
)}

{user && (
              <CommentForm
                cardInfo={cardInfo}
                onCommentSubmit={handleCommentSubmit}
              />
)}

								
									{/* {user && <form onSubmit={handleCommentSubmit}>
                                    <div className="mb-0 text-start">
                                        <label htmlFor="newComment" className="form-label">Post a Comment as {user.username}</label>
                                        <div className="d-flex align-items-start position-relative">
    <textarea
        id="newComment"
        className="form-control"
        value={newComment}
        onChange={handleCommentChange}
        rows="3"
        required
        style={{ paddingTop: "10px", paddingRight: "45px" }} 
    ></textarea>
    <button
        type="button"
        className="btn btn-link position-absolute p-1"
        style={{ top: "2%", right: "0", fontSize: "0.75rem" }} 
        onClick={() => setShowEmotePicker((prev) => !prev)}
    >
        <img 
            src="https://www.hearthcards.net/images/emotes/thinking.png" 
            srcSet="https://www.hearthcards.net/images/emotes/thinking.png 1x, https://www.hearthcards.net/images/emotes/thinking2.png 2x, https://www.hearthcards.net/images/emotes/thinking3.png 4x" 
            style={{ width: "25px", height: "25px" }} 
        />
    </button>
</div>

											<div className={`emote-picker ${showEmotePicker ? 'active' : ''}`}>
												{Object.keys(emoticonMap).map((emote) => {
													const isAnimated = emoticonMap[emote].animated;
													const imgSrc = `https://www.hearthcards.net/images/emotes/${emote}.${isAnimated ? 'gif' : 'png'}`;
													const imgSrcSet = isAnimated
														? null
														: `https://www.hearthcards.net/images/emotes/${emote}.png 1x, https://www.hearthcards.net/images/emotes/${emote}2.png 2x, https://www.hearthcards.net/images/emotes/${emote}3.png 4x`;
													return (
														<img
															key={emote}
															src={imgSrc}
															srcSet={imgSrcSet}
															alt={emote}
															className="emote-picker-img"
															onClick={() => handleEmoteClick(emote)}
														/>
													);
												})}
											</div>
                                        </div>
                                        <div className="d-flex justify-content-end mt-2">
											<Button className="mx-1" variant="primary" type="button"   onClick={() => {
    setCardPickerType('attach');
    setShowPicker(true);
  }}>
											  Attach {selectedCards && selectedCards.length !== 0 ? `${selectedCards.length}` : ''}
											</Button>
                                            <Button variant="primary" type="submit">
                                                Post
                                            </Button>
                                        </div>
                                </form>
									} */}
                                <h6 className="mt-3 commentsHeader">Comments</h6>
                                {totalPages > 1 && (
                                    <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} useHash={true} arrowFlag={false} />
                                )}
                                {comments.map((comment) => (
                                    <>
                                   <div key={comment.id} className={`comment ${Number(comment.sticky) === 1 ? 'comment-sticky mb-3' : 'mb-2 '}`}>
  <div className="row" style={{ alignItems: 'center' }}>
    {comment.userpicture ? (
      <>
        <div className="col-auto pe-2" style={{ paddingRight: '0' }}>
          <Link to={`/user/${comment.userid}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <img 
              src={comment.userpicture.startsWith('http') ? comment.userpicture : `/images/users/pictures/${comment.userpicture}`} 
              alt={`${comment.username}'s profile`} 
              className="img-fluid rounded-circle" 
              style={{ width: '40px', height: '40px'}} 
            />
          </Link>
        </div>
        <div className="col"  style={{ paddingLeft: '0' }}>
          <div className="row">
            <div className="col text-start">
              <strong>
                <Link to={`/user/${comment.userid}`} style={{ textDecoration: 'none', color: comment.supColor || 'inherit' }}>
                  {comment.username} 
                  {comment.userid === cardInfo.creatorId && (
                    <span className="creator-tag"> (author)</span>
                  )}
                </Link>
              </strong>
{comment.supIcon && (
  <img 
    src={`https://www.hearthcards.net/images/emotes/${comment.supIcon}.png`} 
    alt="Supporter Icon"
    className="ps-1"
    style={{ maxHeight: '22px', marginTop: '-2px' }}
  />
)}
            </div>
          </div>
          <div className="row">
            <div className="col text-start">
            {timeSince(comment.date)}
            </div>
          </div>
        </div>
      </>
    ) : (
      <>
        <div className="col text-start">
          <strong>
            <Link to={`/user/${comment.userid}`} style={{ textDecoration: 'none', color: comment.supColor || 'inherit' }}>
              {comment.username}
              {comment.userid === cardInfo.creatorId && (
                <span className="creator-tag"> (author)</span>
              )}
            </Link>
          </strong>
        </div>
        <div className="col-auto text-end">
          {timeSince(comment.date)}
        </div>
      </>
    )}
  </div>
        <div className="row">
            <div className="col text-start">
                {editingCommentId === comment.id ? (
                    <textarea
                        className="form-control"
                        value={editedCommentText}
                        onChange={(e) => setEditedCommentText(e.target.value)}
                        rows="3"
                    />
                ) : (
                    <span className="comment-text" dangerouslySetInnerHTML={{ __html: processCommentText(comment.comment) }}></span>
                )}
            </div>
            {comment.tokens && comment.tokens.length > 0 && (
                <div className="attached-cards my-1 d-flex">
                    {renderCardCarousel(comment.tokens)}
                </div>
            )}
        </div>

        {user && Number(user.userid) === Number(comment.userid) && 
                                            editingCommentId === comment.id && (
                                                <>
                                                <div className="row py-2">
                                                <div className="col text-end d-flex justify-content-end">
                                                    <button
                                                        className="btn btn-link me-1 comment-cancel-button"
                                                        onClick={() => setEditingCommentId(null)}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        className="btn btn-primary comment-save-button"
                                                        onClick={() => handleSaveComment(comment.id)}
                                                    >
                                                        Save
                                                    </button>
                                                    </div>
                                                    </div>
                                                </>
                                            )
                                        }

{editingCommentId !== comment.id && (
                                        <div className="row">
										<div className="col text-end d-flex align-items-center">
                                                <button
                                                    className="btn btn-link p-0 me-2 comment-like-button text-decoration-none"
                                                    onClick={() => handleLikeComment(comment.id)}
                                                >
                                                    {comment.liked ? <FaHeart color="red" /> : <FaRegHeart />} {comment.likes > 0 && comment.likes}
                                                </button>

                                        {user && Number(user.userid) !== Number(comment.userid) && (
                                                <button
                                                    className="btn btn-link p-0 me-2 comment-edit-button align-item-end"
                                                    onClick={() => handleReplyClick(comment.id)}
                                                >
                                                    Reply
                                                </button>
                                        )}

												                                            </div>
<div className="col d-flex justify-content-end">
  <Dropdown>
    <Dropdown.Toggle as="button" className="btn btn-link p-0 comment-options-button text-decoration-none">
      <FaEllipsisV />
    </Dropdown.Toggle>

    <Dropdown.Menu>
	{user && Number(user.userid) !== Number(comment.userid) && (
      <Dropdown.Item onClick={() => openReportModal('comment', comment.id)}>
        <FaFlag className="me-2" /> Report
      </Dropdown.Item>
	)}
	{user && Number(user.userid) === Number(comment.userid) && (
	  <>
		<Dropdown.Item onClick={() => handleEditComment(comment.id)}>
		  <FaEdit className="me-2" /> Edit
		</Dropdown.Item>
		<Dropdown.Item onClick={() => handleDeleteComment(comment.id)}>
		  <FaTrash className="me-2" /> Delete
		</Dropdown.Item>
	  </>
	)}
	{user && user.mod === true && Number(user.userid) !== Number(comment.userid) && (	
		<Dropdown.Item onClick={() => handleModRemoveComment(comment.id)} style={{ color: 'red' }}>
		  <FaShieldAlt className="me-2" color="green" /> Delete
		</Dropdown.Item>	
	)}
    </Dropdown.Menu>
  </Dropdown>
</div>

                                        </div>
                                        )}
                                    </div>
                                    {replyingCommentId && replyingCommentId === Number(comment.id) && (
    <div className="mb-3">
    <CommentForm
              cardInfo={cardInfo}
      onCommentSubmit={(updatedComment) => {
        fetchComments(1);
        setReplyingCommentId(null);
      }}
      initialComment={`@${comment.username}, `}
      commentReplyId={replyingCommentId}
      isReply={true}
    />
    </div>
  )}
                                    </>
                                ))}
                                {totalPages > 1 && (
                                    <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} useHash={true} arrowFlag={false} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

      <ReportModal
        show={showReportModal}
        onHide={() => setShowReportModal(false)}
        reportType={reportType}
        reportItemId={reportItemId}
      />
			
			
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Card</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete this card?</p>
                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>Cancel</Button>
                        <Button variant="danger" className="ms-2" onClick={handleDelete}>Delete</Button>
                    </div>
                </Modal.Body>
            </Modal>
			
			
<Modal show={showShareModal} onHide={() => setShowShareModal(false)} centered>
    <Modal.Header closeButton>
        <Modal.Title>Share Card</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <p>Share this card with others using the link below:</p>
        <InputGroup>
            <Form.Control type="text" value={`https://www.hearthcards.net/gallery/?selectedCard=${card}`} readOnly />
            <Button variant="primary" className="d-flex align-items-center justify-content-center" onClick={handleCopyLink}><FaClipboard /></Button>
            {/* Conditionally render the Download as Image button */}
            {cardInfo && user && Number(user.userid) === Number(cardInfo.creatorId) && (
              <Button className="w-100 mt-3" variant="primary" onClick={handleDownloadImage}>
                Download as Image
              </Button>
            )}
        </InputGroup>
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowShareModal(false)}>
            Close
        </Button>
    </Modal.Footer>
</Modal>


            <Modal show={showCommentDeleteModal} onHide={() => setShowCommentDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Comment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete this comment?</p>
                    <div className="d-flex justify-content-end">
                        <Button variant="secondary" onClick={() => setShowCommentDeleteModal(false)}>Cancel</Button>
                        <Button variant="danger" className="ms-2" onClick={handleDeleteCommentRequest}>Delete</Button>
                    </div>
                </Modal.Body>
            </Modal>




        </>
    );
};

export default CardModal;
